// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderApprovalDetailsActionButtonsStyles } from "@bg/Overrides/Widgets/OrderApprovalDetails/OrderApprovalDetailsActionButtons";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

orderApprovalDetailsActionButtonsStyles.buttonsHiddenContainer = {
    below: "lg",
    css: css`
        span {
            color: ${getColor("text.main")} !important;
        }
        svg {
            color: ${getColor("tertiary.main")} !important;
            fill: ${getColor("tertiary.main")} !important;
        }
    `,
};
